import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";

import { i18n } from "../../translate/i18n";

const ConfirmationModal = ({
  title,
  children,
  open,
  onClose,
  onConfirm,
  maxWidth = "xs",
  fullWidth = false,
  closeOnConfirm = true,
  confirming = false,
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => !confirming && onClose(false)}
      aria-labelledby="confirm-dialog"
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle id="confirm-dialog">{title}</DialogTitle>
      <DialogContent dividers>
        <Typography>{children}</Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={() => onClose(false)}
          color="default"
          disabled={confirming}
        >
          {i18n.t("confirmationModal.buttons.cancel")}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            if (closeOnConfirm) onClose(false);
            onConfirm();
          }}
          color="secondary"
          disabled={confirming}
        >
          {confirming ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            i18n.t("confirmationModal.buttons.confirm")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
